/* istanbul ignore file */
import React, { useState } from 'react';
import { useAuthorization } from 'framework/authorization';
import { Button } from 'framework/ui/mui-builder';
import { Modal } from 'framework/ui/ui-builder';
import AssignAssetOwnerForm from 'domain/finance/assets/shared/AssignAssetOwnerForm';
import { useShowContext } from 'framework/show';
import { UPDATE_ASSET_ASSIGNMENT } from 'domain/finance/assets/useAssetService';

const AssignAssetOwnerButton = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const { data } = useShowContext();
  const { isGranted } = useAuthorization();
  const assignmentDetails = data.getValueBySource('assignmentDetails');
  const hasOwner = !!assignmentDetails?.currentOwner;

  const closeModal = () => {
    setModalOpen(false);
  };

  return isGranted(UPDATE_ASSET_ASSIGNMENT) ? (
    <>
      <Button
        variant="outlined"
        onClick={(e: React.MouseEvent<HTMLElement>) => {
          setModalOpen(true);
          (e.target as HTMLElement).blur();
        }}
      >
        {hasOwner ? 'Reassign' : 'Assign'}
      </Button>
      <Modal
        backdrop="static"
        isOpen={modalOpen}
        title={hasOwner ? 'Reassign asset' : 'Assign asset'}
        onToggle={closeModal}
        hasCancelButton={false}
      >
        <AssignAssetOwnerForm closeModal={closeModal} modalOpen={modalOpen} />
      </Modal>
    </>
  ) : null;
};

export default AssignAssetOwnerButton;
